<template>
  <div id="base" class="form-container" v-title title="资料填写">
    <!-- 顶部导航栏 -->
    <div class="header">
      <div class="header-content">
        <img id="u52_img" class="background-img"  src="@/images/shenqin/u52.png" alt="Logo"/>
      </div>
    </div>

    <!-- 主内容区 -->
    <div class="main-content">
      <!-- 页面标题和进度 -->
      <div class="page-header">
        <div class="page-title">
          <div class="title-icon">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
            </svg>
          </div>
          <h1>机构信息填写</h1>
          <p>请准确填写机构基本信息，带<span class="required-mark">*</span>为必填项</p>
        </div>
        
        <!-- 步骤指示器 -->
        <div class="step-indicator">
          <div class="step active">
            <div class="step-circle">1</div>
            <div class="step-label">填写基本信息</div>
          </div>
          <div class="step-line"></div>
          <div class="step">
            <div class="step-circle">2</div>
            <div class="step-label">上传资料文件</div>
          </div>
          <div class="step-line"></div>
          <div class="step">
            <div class="step-circle">3</div>
            <div class="step-label">提交审核</div>
          </div>
        </div>
      </div>

      <!-- 表单区域 -->
      <div class="form-card">
        <el-form ref="form" :model="form" label-width="140px" class="custom-form">
          <!-- 所属地区 -->
          <div class="form-section">
            <div class="section-header">
              <div class="section-icon">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/>
                </svg>
              </div>
              <h3>机构基本信息</h3>
              <p>填写机构的详细注册信息</p>
            </div>
            
            <el-row :gutter="30">
              <el-col :span="24">
                <el-form-item label="所属地区" required>
                  <div class="region-selectors">
                    <el-select
                      v-model="form.province"
                      placeholder="请选择省"
                      @change="changeDept($event,0)"
                      class="region-select"
                    >
                      <el-option
                        v-for="item in provinceArry"
                        :key="item.deptId"
                        :label="item.deptName"
                        :value="item.deptId"
                      ></el-option>
                    </el-select>
                    <el-select
                      v-model="form.city"
                      placeholder="请选择市"
                      @change="changeDept($event,1)"
                      class="region-select"
                      :disabled="!form.province"
                    >
                      <el-option
                        v-for="item in cityArry"
                        :key="item.deptId"
                        :label="item.deptName"
                        :value="item.deptId"
                      ></el-option>
                    </el-select>
                    <el-select
                      v-model="form.district"
                      placeholder="请选择区"
                      @change="changeDept($event,2)"
                      class="region-select"
                      :disabled="!form.city"
                    >
                      <el-option
                        v-for="item in districtArry"
                        :key="item.deptId"
                        :label="item.deptName"
                        :value="item.deptId"
                      ></el-option>
                    </el-select>
                  </div>
                  <div class="form-hint">请选择机构所属地区</div>
                </el-form-item>
              </el-col>
              
              <el-col :span="24">
                <el-form-item label="机构名称" prop="orgName" required>
                  <el-input 
                    v-model="form.orgName"  
                    :maxlength="30" 
                    placeholder="请输入机构名称"
                    class="form-input"
                  />
                  <div class="form-hint">请输入完整的机构名称，最多30个字符</div>
                </el-form-item>
              </el-col>
              
              <el-col :span="24">
                <el-form-item label="成立时间" prop="establishDate" required>
                  <el-date-picker
                    type="date"
                    v-model="form.establishDate"
                    placeholder="请选择成立日期"
                    value-format="YYYY-MM-DD"
                    :disabledDate="pickerOptions"
                    class="form-datepicker"
                  />
                  <div class="form-hint">请选择机构成立的日期</div>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 法人信息 -->
          <div class="form-section">
            <div class="section-header">
              <div class="section-icon">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                </svg>
              </div>
              <h3>法人信息</h3>
              <p>填写机构法人代表信息</p>
            </div>
            
            <el-row :gutter="30">
              <el-col :span="24">
                <el-form-item label="法人姓名" prop="orgHeader" required>
                  <el-input 
                    v-model="form.orgHeader"  
                    :maxlength="30"
                    placeholder="请输入法人姓名"
                    class="form-input"
                  />
                  <div class="form-hint">请输入法人真实姓名</div>
                </el-form-item>
              </el-col>
              
              <el-col :span="24">
                <el-form-item label="手机号码" prop="orgHeaderPhone" required>
                  <el-input 
                    v-model="form.orgHeaderPhone"  
                    :maxlength="11" 
                    @blur="checkPhoneNumber"
                    placeholder="请输入法人手机号码"
                    class="form-input"
                  />
                  <div class="form-hint">请输入11位手机号码</div>
                </el-form-item>
              </el-col>
              
              <el-col :span="24">
                <el-form-item label="身份证号" prop="idcardNo" required>
                  <el-input 
                    v-model="form.idcardNo"  
                    :maxlength="20" 
                    @blur="checkIdCardNumber"
                    placeholder="请输入法人身份证号码"
                    class="form-input"
                  />
                  <div class="form-hint">请输入18位身份证号码</div>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 营业执照 -->
          <div class="form-section">
            <div class="section-header">
              <div class="section-icon">
                <svg viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z"/>
                </svg>
              </div>
              <h3>营业执照</h3>
              <p>上传机构相关证明文件</p>
            </div>
            
            <el-row :gutter="30">
              <el-col :span="24">
                <el-form-item label="营业执照" prop="licenseImg" required>
                  <div class="upload-area">
                    <div class="upload-info">
                      <div class="upload-icon">
                        <svg viewBox="0 0 24 24" fill="currentColor">
                          <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"/>
                        </svg>
                      </div>
                      <div class="upload-text">
                        <h4>上传营业执照</h4>
                        <p>支持 JPG、JPEG、PNG 格式，文件大小不超过5MB</p>
                      </div>
                    </div>
                    
                    <el-upload
                      ref="upload"
                      list-type="picture-card"
                      name="licenseImg"
                      action="void"
                      :http-request="customUploads"
                      :multiple="false"
                      :limit="1"
                      :class="{ 'disUoloadPic3': hideUpload3 }"
                      :on-change="handleUploadHide3"
                      :on-remove="handleRemove3"
                      :on-preview="handlePictureCardPreview3"
                      accept=".jpg, .jpeg, .png"
                      class="license-upload"
                    >
                      <el-icon>
                        <plus/>
                      </el-icon>
                    </el-upload>
                    
                    <el-dialog append-to-body
                              title="营业执照预览"
                              v-model="dialogVisible3"
                              width="600px"
                              class="preview-dialog">
                      <img
                        :src="dialogImageUrl3"
                        class="preview-image"
                        :preview-src-list="licenseImgList"
                      />
                      <div class="dialog-footer">
                        <el-button type="primary" @click="dialogVisible3 = false, dialogImageUrl3 = ''">关闭预览</el-button>
                      </div>
                    </el-dialog>
                  </div>
                  <div class="form-hint">请上传清晰的营业执照照片，确保信息清晰可见</div>
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 表单操作按钮 -->
          <div class="form-actions">
            <el-button class="btn-secondary" @click="goIndex">
              <svg viewBox="0 0 24 24" fill="currentColor" class="btn-icon">
                <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/>
              </svg>
              返回首页
            </el-button>
            <el-button type="primary" class="btn-primary" @click="submit">
              提交审核
              <svg viewBox="0 0 24 24" fill="currentColor" class="btn-icon">
                <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
              </svg>
            </el-button>
          </div>
        </el-form>
      </div>
    </div>

    <!-- 底部版权信息 -->
    <div class="footer">
      <div class="footer-content">
        <div class="footer-links">
          <div class="link-item">
            <strong>主办：</strong>河北省体育局
          </div>
          <div class="link-item">
            <strong>地址：</strong>河北省石家庄市中山东路372号
          </div>
          <div class="link-item">
            <strong>邮编：</strong>050011
          </div>
          <div class="link-item">
            <strong>邮箱：</strong>hebeitiyuju@163.com
          </div>
          <div class="link-item">
            <strong>运维电话：</strong>0311-85266259
          </div>
        </div>
        <div class="footer-copyright">
          <p>河北省体育局版权所有 © 2025</p>
          <p class="icp-info">
            冀ICP备：2022017224号 | 冀公网安备：13010202002305号
          </p>
        </div>
      </div>
    </div>
  </div>
</template>


<script>

import {
  getDeptList,
  saveOrgInfo
} from "@/requst/api";
import {ElMessage} from "element-plus";
import Compressor from "compressorjs";
import { Plus } from '@element-plus/icons-vue'

export default {
  name: 'KaiHu',
    components: {
        Plus
    },
  data() {
    return {
      // 区域树选项
      deptOptions: undefined,
      form: {
          establishDate: null,
      },
      dialogImageUrl1: '',
      dialogVisible1: false,
      dialogImageUrl2: '',
      dialogVisible2: false,
      dialogImageUrl3: '',
      dialogVisible3: false,

      hideUpload1: false,
      hideUpload2: false,
      hideUpload3: false,
      limitCount: 1,
      provinceArry: {},
      cityArry: {},
      districtArry: {},

      frontImgList:[],
      backImgList:[],
      licenseImgList:[]
    }
  },


  created() {
    //所属城市列表
    this.getProvinceList(0);
  },
  methods: {
      pickerOptions(time) {
          return time.getTime() > Date.now();
      },
      proving(params) {
          this.form.memberNnum = params.match(/\d+(\.\d{0,2})?/) ? params.match(/\d+(\.\d{0,2})?/)[0] : '';

      },

      checkPhoneNumber() {
          const phoneReg = /^1[3456789]\d{9}$/
          if (!phoneReg.test(this.form.orgHeaderPhone)) {
              ElMessage.error('手机号码格式错误')
              return false;
          }
      },

      checkIdCardNumber(){
          const phoneReg = /^[1-9]\d{5}(19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[Xx\d]$/
          if (!phoneReg.test(this.form.idcardNo)) {
              ElMessage.error('法人身份证号格式错误')
              return false;
          }
      },
    /** 查询省下拉树结构 */
    getProvinceList(deptId) {
         let queryParams ={
             parentId : deptId
         }
        getDeptList(queryParams).then(response => {
            this.provinceArry = response.data;
        });
    },
    /** 查询市下拉树结构 */
    getCityList(deptId) {
        let queryParams ={
            parentId : deptId
        }
        getDeptList(queryParams).then(response => {
            this.cityArry = response.data;
        });
    },
    /** 查询区下拉树结构 */
    getDistrictList(deptId) {
        let queryParams ={
            parentId : deptId
        }
        getDeptList(queryParams).then(response => {
            this.districtArry = response.data;
        });
    },
    changeDept(data, type){
        //省下拉框改变
        if (type == 0) {
            this.getCityList(data);
        }
        //市下拉框改变
        if (type == 1) {
            this.getDistrictList(data);
            this.form.deptId = data;
            this.form.district=''
        }
        //区下拉框改变
        if (type == 2) {
            this.form.deptId = data;
        }
    },
      customUpload(file) {
          const loading = this.$loading({
              lock: true,//lock的修改符--默认是false
              text: '资源正在上传，请耐心等候……',//显示在加载图标下方的加载文案
              spinner: 'el-icon-loading',//自定义加载图标类名
              background: 'rgba(0, 0, 0, 0.7)',//遮罩层颜色
              target: document.querySelector('#table')//loadin覆盖的dom元素节点
          });
          let _this = this
          let wz = file.file.name.split('.')[1];
          if (wz == 'jpg' || wz == 'png') {
              new Compressor(file.file, {
                  quality: 0.1,
                  success(result) {
                      let filess = new File([result], file.file.name, {type: file.file.type})
                      var FormDatas = new FormData();
                      FormDatas.append('file', filess);
                      _this.$http.post('/api/file/uploadQny', FormDatas, {
                          headers: {
                              'Content-Type': 'multipart/form-data'
                          }
                      }).then((response) => {
                          loading.close();

                          let str = response.data.msg

                          if (file.filename == 'licenseImg') {
                              _this.form.licenseImg = str
                              _this.licenseImgList.push(str)
                          } else if (file.filename == 'idcardFrontImg') {
                              _this.form.idcardFrontImg = str
                              _this.frontImgList.push(str)
                          } else if (file.filename == 'idcardBackImg') {
                              _this.form.idcardBackImg = str
                              _this.backImgList.push(str)
                          }
                          localStorage.setItem('form1', JSON.stringify(_this.form))
                      }).catch(e => {
                          loading.close();
                          ElMessage.error('上传失败')
                          console.log(e)
                      })
                  },
                  error(err) {
                      //错误处理
                      console.log(err.message)
                  }
              })
          } else {
              let FormDatas = new FormData();
              FormDatas.append('file', file.file);
              _this.$http.post('/api/file/uploadQny', FormDatas, {
                  headers: {
                      'Content-Type': 'multipart/form-data'
                  }
              }).then((response) => {
                  loading.close();
                  let str = response.data.msg
                  if (file.filename == 'licenseImg') {
                      _this.form.licenseImg = str
                      this.licenseImgList.push(str)
                  } else if (file.filename == 'idcardFrontImg') {
                      _this.form.idcardFrontImg = str
                      this.frontImgList.push(str)
                  } else if (file.filename == 'idcardBackImg') {
                      _this.form.idcardBackImg = str
                      this.backImgList.push(str)
                  }
                  localStorage.setItem('form1', JSON.stringify(_this.form))
              }).catch(e => {
                  loading.close();
                  ElMessage.error('上传失败')
                  console.log(e)
              })
          }
      },
      handleUploadHide1(file, fileList) {
          this.hideUpload1 = fileList.length >= this.limitCount;
      },
      handleRemove1(file, fileList) {
          this.hideUpload1 = fileList.length >= this.limitCount;
      },
      handleUploadHide2(file, fileList) {
          this.hideUpload2 = fileList.length >= this.limitCount;
      },
      handleRemove2(file, fileList) {
          this.hideUpload2 = fileList.length >= this.limitCount;
      },
      handleUploadHide3(file, fileList) {
          this.hideUpload3 = fileList.length >= this.limitCount;
      },
      handleRemove3(file, fileList) {
          this.hideUpload3 = fileList.length >= this.limitCount;
      },

    customUploads(file) {
        const loading = this.$loading({
            lock: true,//lock的修改符--默认是false
            text: '资源正在上传，请耐心等候……',//显示在加载图标下方的加载文案
            spinner: 'el-icon-loading',//自定义加载图标类名
            background: 'rgba(0, 0, 0, 0.7)',//遮罩层颜色
            target: document.querySelector('#table')//loadin覆盖的dom元素节点
        });
        console.log(file.file)
        let _this = this
        let wz = file.file.name.split('.')[1];
        if (wz == 'jpg' || wz == 'png') {
            new Compressor(file.file, {
                quality: 0.1,
                success(result) {
                    let filess = new File([result], file.file.name, {type: file.file.type})
                    console.log(result)
                    var FormDatas = new FormData();
                    FormDatas.append('file', filess);
                    _this.$http.post('/api/file/uploadQny', FormDatas, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }).then((response) => {
                        loading.close();
                        let str = response.data.msg
                        if (file.filename == 'licenseImg') {
                            _this.form.licenseImg = str
                        }
                        localStorage.setItem('form1', JSON.stringify(_this.form))
                    }).catch(e => {
                        loading.close();
                        ElMessage.error('上传失败')
                        console.log(e)
                    })
                },
                error(err) {
                    //错误处理
                    console.log(err.message)
                }
            })
        } else {
            let FormDatas = new FormData();
            FormDatas.append('file', file.file);
            _this.$http.post('/api/file/uploadQny', FormDatas, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then((response) => {
                loading.close();
                let str = response.data.msg
                if (file.filename == 'licenseImg') {
                    _this.form.licenseImg = str
                }
                localStorage.setItem('form1', JSON.stringify(_this.form))
            }).catch(e => {
                loading.close();
                ElMessage.error('上传失败')
                console.log(e)
            })
        }
        this.licenseImgList.push(_this.form.licenseImg)
    },
   /* handleRemove(file, fileList) {
        console.log(file, fileList);
    },*/
    handlePictureCardPreview1() {
        console.log(this.form.idcardFrontImg)
        this.dialogImageUrl1 = this.form.idcardFrontImg;
        //this.dialogImageUrl = file.url;
        this.dialogVisible1 = true;
    },
    handlePictureCardPreview2() {
        this.dialogImageUrl2 = this.form.idcardBackImg;
        this.dialogVisible2 = true;
    },
    handlePictureCardPreview3() {
        this.dialogImageUrl3 = this.form.licenseImg;
        this.dialogVisible3 = true;
    },
    goIndex(){
        this.$router.push('/')
    },
    //提交保存
    submit(){
        if (!this.form.district) {
            ElMessage.error('请选择所属地区')
            return false;
        }
        if (!this.form.orgName) {
            ElMessage.error('请输入机构名称')
            return false;
        }
        if (!this.form.establishDate) {
            ElMessage.error('请选择成立时间')
            return false;
        }
        if (!this.form.orgHeader) {
            ElMessage.error('请输入法人姓名')
            return false;
        }
        if (!this.form.orgHeaderPhone) {
            ElMessage.error('请输入法人手机号码')
            return false;
        }
        //校验手机号格式
        const phoneReg = /^1[3456789]\d{9}$/
        if (!phoneReg.test(this.form.orgHeaderPhone)) {
            ElMessage.error('法人手机号码格式错误')
            return false;
        }
        if (!this.form.idcardNo) {
            ElMessage.error('请输入法人身份证号')
            return false;
        }
        //校验身份证号
        const idCardReg = /^[1-9]\d{5}(19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[Xx\d]$/
        if (!idCardReg.test(this.form.idcardNo)) {
            ElMessage.error('法人身份证号格式错误')
            return false;
        }

        /*if (!this.form.idcardFrontImg) {
            ElMessage.error('请上传法人身份证正面照片')
            return false;
        }
        if (!this.form.idcardBackImg) {
            ElMessage.error('请上传法人身份证反面照片')
            return false;
        }*/
        if (!this.form.licenseImg) {
            ElMessage.error('请上传营业执照')
            return false;
        }
        let _this = this
        saveOrgInfo(this.form).then(response => {
            console.log(response.code)
            if(response.code == 200){
                ElMessage.success('提交成功');
                localStorage.setItem('kaihu', JSON.stringify(this.form))
                this.form={};
                setTimeout(function () {
                    _this.$router.push('/kaihuSuccess')
                }, 1000)

            }else{
                ElMessage.error(response.msg);
            }


        });
    }
  }
}
</script> 

<style scoped>
.form-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8f0 100%);
}

/* 顶部导航栏样式 */
.header {
  background: white;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  position: relative;
  z-index: 10;
}

.header-content {
  max-width: 1200px;
  margin: 0 auto; 
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-background {
  flex: 1;
  display: flex;
  justify-content: center;
}

.background-img {
  width: 100%; 
  height: auto;
  border-radius: 16px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
  overflow: hidden; /* 确保图片内容不会超出圆角边界 */
}

.logo {
  height: 50px;
  width: auto;
}

/* 主内容区样式 */
.main-content {
  flex: 1;
  max-width: 1200px;
  margin: 0 auto;
  padding-top: 30px;
  width: 100%;
}

/* 页面标题区域 */
.page-header {
  margin-bottom: 40px;
}

.page-title {
  text-align: center;
  margin-bottom: 40px;
}

.title-icon {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  color: white;
}

.title-icon svg {
  width: 30px;
  height: 30px;
}

.page-title h1 {
  font-size: 32px;
  font-weight: 600;
  color: #1a1a1a;
  margin-bottom: 10px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.page-title p {
  font-size: 16px;
  color: #666;
}

.required-mark {
  color: #ff4d4f;
  font-weight: bold;
  margin: 0 4px;
}

/* 步骤指示器 */
.step-indicator {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 600px;
  margin: 0 auto;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
}

.step-circle {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #e9ecef;
  color: #666;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 8px;
  transition: all 0.3s ease;
}

.step.active .step-circle {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

.step-label {
  font-size: 14px;
  color: #666;
  text-align: center;
}

.step.active .step-label {
  color: #667eea;
  font-weight: 500;
}

.step-line {
  flex: 1;
  height: 2px;
  background: #e9ecef;
  margin: 0 20px;
  position: relative;
  top: -20px;
}

/* 表单卡片 */
.form-card {
  background: white;
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

/* 表单区域样式 */
.form-section {
  margin-bottom: 40px;
  padding-bottom: 30px;
  border-bottom: 1px solid #f0f0f0;
}

.form-section:last-child {
  border-bottom: none;
  margin-bottom: 0;
  padding-bottom: 0;
}

.section-header {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}

.section-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: linear-gradient(135deg, #667eea20 0%, #764ba220 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  color: #667eea;
}

.section-icon svg {
  width: 24px;
  height: 24px;
}

.section-header h3 {
  font-size: 20px;
  color: #333;
  margin: 0 0 4px 0;
}

.section-header p {
  color: #666;
  margin: 0;
  font-size: 14px;
}

/* 表单项样式 */
:deep(.el-form-item) {
  margin-bottom: 24px;
}

:deep(.el-form-item__label) {
  font-size: 16px;
  color: #333;
  font-weight: 500;
  padding-right: 20px;
}

:deep(.el-form-item.is-required .el-form-item__label:before) {
  display: none;
}

/* 地区选择器 */
.region-selectors {
  display: flex;
  gap: 15px;
}

.region-select {
  flex: 1;
}

/* 输入框样式 */
.form-input {
  width: 100%;
}

:deep(.el-input__wrapper) {
  border-radius: 8px;
  border: 1px solid #dcdfe6;
  transition: all 0.3s ease;
}

:deep(.el-input__wrapper:hover) {
  border-color: #409eff;
}

:deep(.el-input__wrapper.is-focus) {
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
}

/* 日期选择器 */
.form-datepicker {
  width: 100%;
}

/* 表单提示 */
.form-hint {
  font-size: 13px;
  color: #999;
  margin-top: 6px;
  line-height: 1.4;
}

/* 上传区域 */
.upload-area {
  border: 2px dashed #d9d9d9;
  border-radius: 12px;
  padding: 30px;
  background: #fafafa;
  transition: all 0.3s ease;
}

.upload-area:hover {
  border-color: #409eff;
  background: #f0f9ff;
}

.upload-info {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.upload-icon {
  width: 50px;
  height: 50px;
  border-radius: 10px;
  background: linear-gradient(135deg, #667eea20 0%, #764ba220 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
  color: #667eea;
}

.upload-icon svg {
  width: 24px;
  height: 24px;
}

.upload-text h4 {
  font-size: 16px;
  color: #333;
  margin: 0 0 4px 0;
}

.upload-text p {
  font-size: 14px;
  color: #666;
  margin: 0;
}

.license-upload {
  margin-top: 20px;
}

:deep(.el-upload--picture-card) {
  width: 120px;
  height: 120px;
  border-radius: 8px;
  border: 2px dashed #d9d9d9;
  background: white;
}

:deep(.el-upload--picture-card:hover) {
  border-color: #409eff;
}

/* 预览对话框 */
.preview-dialog :deep(.el-dialog__header) {
  border-bottom: 1px solid #f0f0f0;
  margin: 0;
  padding: 20px 24px;
}

.preview-dialog :deep(.el-dialog__body) {
  padding: 24px;
}

.preview-image {
  width: 100%;
  max-height: 400px;
  object-fit: contain;
  border-radius: 8px;
}

.dialog-footer {
  text-align: center;
  margin-top: 20px;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
}

/* 表单操作按钮 */
.form-actions {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 40px;
  padding-top: 30px;
  border-top: 1px solid #f0f0f0;
}

.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  border-radius: 8px;
  padding: 12px 30px;
  font-size: 16px;
  font-weight: 500;
  height: auto;
  color: white;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.2);
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.3);
}

.btn-secondary {
  background: white;
  border: 2px solid #dcdfe6;
  border-radius: 8px;
  padding: 12px 30px;
  font-size: 16px;
  font-weight: 500;
  height: auto;
  color: #333;
  transition: all 0.3s ease;
}

.btn-secondary:hover {
  border-color: #667eea;
  color: #667eea;
  background: #f0f9ff;
}

.btn-icon {
  width: 16px;
  height: 16px;
  margin: 0 8px;
}

.btn-primary .btn-icon {
  margin-left: 8px;
  margin-right: 0;
}

.btn-secondary .btn-icon {
  margin-right: 8px;
  margin-left: 0;
}

/* 底部样式 */
.footer {
  background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);
  color: #fff;
  padding: 40px 0 20px;
  margin-top: 60px;
}

.footer-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 30px;
}

.footer-links {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
  padding-bottom: 30px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.link-item {
  color: #aaa;
  line-height: 1.8;
}

.link-item strong {
  color: #ccc;
}

.footer-copyright {
  text-align: center;
  color: #888;
  font-size: 14px;
}

.footer-copyright p {
  margin: 5px 0;
}

.icp-info {
  font-size: 13px;
  color: #666;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .header-content {
    flex-direction: column;
    gap: 20px;
    text-align: center;
  }
  
  .main-content {
    padding: 20px;
  }
  
  .form-card {
    padding: 25px;
  }
  
  .region-selectors {
    flex-direction: column;
    gap: 10px;
  }
  
  .section-header {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .section-icon {
    margin-right: 0;
    margin-bottom: 12px;
  }
  
  .upload-info {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .upload-icon {
    margin-right: 0;
    margin-bottom: 12px;
  }
  
  .form-actions {
    flex-direction: column;
    gap: 15px;
  }
  
  .btn-primary,
  .btn-secondary {
    width: 100%;
  }
  
  .step-indicator {
    flex-direction: column;
    gap: 20px;
  }
  
  .step-line {
    width: 2px;
    height: 40px;
    margin: 0;
  }
  
  .footer-links {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .page-title h1 {
    font-size: 24px;
  }
  
  .section-header h3 {
    font-size: 18px;
  }
  
  :deep(.el-form-item__label) {
    font-size: 14px;
  }
}
</style>